<section class="flex w-full flex-col gap-6 bg-zinc-50 pt-15 pb-10 lg:gap-10 lg:py-25">
  <div class="container flex flex-col gap-4 px-4 text-center">
    <h1 class="sb-aggro text-lg font-bold text-zinc-800 lg:text-4xl">SPONSOR</h1>
    <p class="text-sm text-zinc-500 lg:text-base">마이스 좋은공간은 고객들의 최고의 가치를 창출하고 있습니다.</p>
  </div>

  @if (sponsors().length > 0) {
  <div
    class="container px-4"
    (window:resize)="onWindowResize()"
    [style.--sponsor-duration]="desktopDuration()"
    [style.--sponsor-duration-m]="mobileDuration()"
    [style.--sponsor-duration-r]="reverseDuration()">
    <div class="sponsor-section flex w-full flex-col gap-6">
      @if (screenSize.isMobileSize()) {
      <div class="sponsor-marquee__mask sponsor-marquee__mask--mobile">
        <div #mobileTrack class="sponsor-marquee__track sponsor-marquee__track--mobile">
          @for (sponsor of sponsorTrack(); track sponsor.id + '-mobile-' + $index) {
          <div class="sponsor-logo-item sponsor-logo-item--mobile">
            @if (sponsor.link) {
            <a [href]="sponsor.link" target="_blank" rel="noopener noreferrer">
              <img
                [src]="sponsor.logo"
                [alt]="sponsor.name"
                class="sponsor-logo-image"
                (load)="onImgLoad()"
                (error)="onImgError($event)" />
            </a>
            } @else {
            <img
              [src]="sponsor.logo"
              [alt]="sponsor.name"
              class="sponsor-logo-image"
              (load)="onImgLoad()"
              (error)="onImgError($event)" />
            }
          </div>
          }
        </div>
      </div>
      } @else {
      <div class="sponsor-marquee__mask">
        <div #desktopTrack class="sponsor-marquee__track">
          @for (sponsor of sponsorTrack(); track sponsor.id + '-desktop-' + $index) {
          <div class="sponsor-logo-item">
            @if (sponsor.link) {
            <a [href]="sponsor.link" target="_blank" rel="noopener noreferrer">
              <img
                [src]="sponsor.logo"
                [alt]="sponsor.name"
                class="sponsor-logo-image"
                (load)="onImgLoad()"
                (error)="onImgError($event)" />
            </a>
            } @else {
            <img
              [src]="sponsor.logo"
              [alt]="sponsor.name"
              class="sponsor-logo-image"
              (load)="onImgLoad()"
              (error)="onImgError($event)" />
            }
          </div>
          }
        </div>
      </div>

      <div class="sponsor-marquee__mask">
        <div #reverseTrack class="sponsor-marquee__track sponsor-marquee__track--reverse">
          @for (sponsor of sponsorTrackReversed(); track sponsor.id + '-reverse-' + $index) {
          <div class="sponsor-logo-item sponsor-logo-item--muted">
            @if (sponsor.link) {
            <a [href]="sponsor.link" target="_blank" rel="noopener noreferrer">
              <img
                [src]="sponsor.logo"
                [alt]="sponsor.name"
                class="sponsor-logo-image"
                (load)="onImgLoad()"
                (error)="onImgError($event)" />
            </a>
            } @else {
            <img
              [src]="sponsor.logo"
              [alt]="sponsor.name"
              class="sponsor-logo-image"
              (load)="onImgLoad()"
              (error)="onImgError($event)" />
            }
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>
  } @else {
  <div class="flex items-center justify-center py-10">
    <p class="text-zinc-400 font-medium">등록된 스폰서가 없습니다.</p>
  </div>
  }
</section>
